import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["select", "otherField"];

  connect() {
    this.toggleOtherField();
  }

  toggleOtherField() {
    const isOther = this.selectTarget.value === "other";
    this.otherFieldTarget.classList.toggle("hidden", !isOther);
  }
}
